import { render, staticRenderFns } from "./RetailerPopup.vue?vue&type=template&id=06720cfc"
import script from "./RetailerPopup.vue?vue&type=script&lang=js"
export * from "./RetailerPopup.vue?vue&type=script&lang=js"
import style0 from "./RetailerPopup.vue?vue&type=style&index=0&id=06720cfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports